import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Pricing from '../components/Pricing';
import FAQ from '../components/FAQ';

export default function PricingPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0b] flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Pricing />
        <FAQ />
      </main>
      <Footer />
    </div>
  );
}
